<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      shape="square"
      finish-button-text="Add Device"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Network -->
      <tab-content
        title="Network"
        :before-change="validationNetwork"
      >
        <validation-observer
          ref="network"
          tag="form"
        />
        <add-network-details :network-details="networkDetails" />
      </tab-content>

      <!-- Summary -->
      <tab-content
        title="Summary"
      >
        <validation-observer
          ref="deviceInfo"
          tag="form"
        />

      </tab-content>

    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import { API } from 'aws-amplify'
// import * as mutations from '../../../graphql/mutations'
import AddNetworkDetails from './AddNetworkDetails.vue'

export default {
  components: {
    ValidationObserver,
    FormWizard,
    TabContent,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AddNetworkDetails,
  },
  data() {
    return {
      networkDetails: {
        name: '',
        network_id: '',
        api_key: '',
      },
    }
  },
  methods: {
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    async formSubmitted() {
      // eslint-disable-next-line no-unused-vars
      const counter = 'count'
    },
    validationNetwork() {
      return new Promise((resolve, reject) => {
        this.$refs.network.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-autosuggest.scss';
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  .repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
